export default "__VITE_ASSET__qPPrsRri__"